import type { AppStoreState } from '@runtime/core/store/appStoreTypes'
import type { AppStoreSlice } from '@runtime/core/store/slices/sliceTypes'

type UiSlice = Pick<AppStoreState, 'ui' | 'setPosterOpen' | 'setLoginOpen'>

export const createUiSlice: AppStoreSlice<UiSlice> = (set) => ({
  ui: {
    posterOpen: false,
    loginOpen: false,
  },

  setPosterOpen: (open: boolean) => {
    set((s) => ({ ui: { ...s.ui, posterOpen: !!open } }))
  },

  setLoginOpen: (open: boolean) => {
    set((s) => ({ ui: { ...s.ui, loginOpen: !!open } }))
  },
})
